// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, number, string, any } from "@altostra/type-validations/lib/primitives";

const isAppSettingsCustomAttributesDataObject = objectOf({
  name: string,
  blacklisted: boolean,
  array_length: maybe(number, true),
  detected_data_type: string,
  schema: maybe(any, true),
  schema_status: string,
  can_regenerate_schema: boolean,
  has_missing_fields: maybe(boolean, true),
  in_use: maybe(boolean, true),
});

export const isAppSettingsCustomAttributeDataResult = objectOf({
  hits: number,
  results: arrayOf(isAppSettingsCustomAttributesDataObject),
  max_array_length: number,
});
